export const randomObservationEndpoint = () => '/question/random'
export const answerEndpoint = () => '/answer/list'
export const questionTypesEndpoint = () => '/question/type'
export const contactEndpoint = () => '/contact/email'
